import React, { useState, createRef } from "react";
import {
  FormFlex,
  FormFlexDiv,
  TabContentWrapper,
  InlineFormDiv,
  AccountSummaryWrapper,
} from "../../pages/Dashboard/styles/dashboard.style";
import DatePickerComponent from "../datepicker/DatePicker";
import PropTypes from "prop-types";
import colors from "../../assets/colors.json";
import FormLoader from "../FormLoader";
import { InputWrapper, AuthButton } from "../../pages/auth/Login.style";
import { useMediaQuery } from "react-responsive";
import moment from "moment/moment";
const Education = ({
  data,
  obj,
  setObj,
  action,
  showForm,
  formLoading,
  clearFields,
}) => {
  const onPickFileRef = createRef();
  const [fileName, setFileName] = useState("");
  const isTab = useMediaQuery({ maxWidth: 992 });
  
  

  const pickFile = () => {
    onPickFileRef.current.click();
  };
  const onPickFile = (event) => {
    const files = event.target.files;

    let filename = files[0].name;
    if (
      filename.includes(".pdf") ||
      filename.includes(".doc") ||
      filename.includes(".docx") ||
      filename.includes(".jpg") ||
      filename.includes(".jpeg") ||
      filename.includes(".png")
    ) {
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        setFileName(files[0].name);
        setObj({ ...obj, proofFileBase64: fileReader.result });
      });
      fileReader.readAsDataURL(files[0]);
    } else {
      alert("Please upload a document");
    }
  };

  return (
    <TabContentWrapper>
      {showForm && (
        <>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="School">School</label>
                <input
                  type="text"
                  placeholder="School"
                  value={obj.school}
                  onChange={(e) => setObj({ ...obj, school: e.target.value })}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Degree">Degree</label>
                <input
                  type="text"
                  placeholder="Degree"
                  value={obj.degree}
                  onChange={(e) => setObj({ ...obj, degree: e.target.value })}
                  readOnly
                />
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="Course">Course</label>
                <input
                  type="text"
                  placeholder="Course"
                  value={obj.course}
                  onChange={(e) => setObj({ ...obj, course: e.target.value })}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <label htmlFor="Grade">Grade</label>
                <input
                  type="text"
                  placeholder="Grade"
                  value={obj.grade}
                  onChange={(e) => setObj({ ...obj, grade: e.target.value })}
                  readOnly
                />
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="">Start Date</label>

                <DatePickerComponent
                  selected={
                    obj.startDate === "" || obj.startDate === null
                      ? ""
                      : new Date(Date.parse(obj.startDate))
                  }
                  setSelected={(val) => setObj({ ...obj, startDate: val })}
                  disabled
                />
              </InputWrapper>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="">End Date</label>

                <DatePickerComponent
                  selected={
                    obj.endDate === "" || obj.endDate === null
                      ? ""
                      : new Date(Date.parse(obj.endDate))
                  }
                  setSelected={(val) => setObj({ ...obj, endDate: val })}
                  disabled
                />
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          <FormFlex>
            <input
              type="file"
              style={{
                display: "none",
              }}
              onChange={onPickFile}
              ref={onPickFileRef}
            />
            <FormFlexDiv>
              <InlineFormDiv
                style={{ padding: "0px" }}
                maxwidth="100%"
                width="100%"
              >
                {/* <div style={{ width: isTab ? "100%" : "70%" }}>
                  <InputWrapper>
                    <label htmlFor="filename">Proof Of Qualification</label>
                    <input
                      type="text"
                      value={obj.proofFileBase64 ? fileName : ""}
                      placeholder="File Name"
                      readOnly
                    />
                  </InputWrapper>
                </div> */}

                {/* <AuthButton
                  width={isTab ? "100%" : "20%"}
                  onClick={pickFile}
                  bg={colors.secondary}
                  color={colors.primary}
                >
                  Upload File
                </AuthButton> */}
              </InlineFormDiv>
            </FormFlexDiv>
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="comments">Comments</label>
                <input
                  type="text"
                  placeholder="Comments"
                  value={obj.comments}
                  onChange={(e) => setObj({ ...obj, comments: e.target.value })}
                  readOnly
                />
              </InputWrapper>
            </FormFlexDiv>
          </FormFlex>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: isTab ? "column" : "row",
            }}
          >
            <AuthButton
              width={isTab ? "100%" : "30%"}
              onClick={action}
              disabled={formLoading}
            >
              {formLoading ? (
                <FormLoader />
              ) : (
                <div>
                  <span>
                    {obj.id ? "Edit" : "Add"} Educational Qualification
                  </span>
                </div>
              )}

              Send Code
            </AuthButton>
            {obj.id && (
              <AuthButton
                onClick={clearFields}
                width={isTab ? "100%" : "30%"}
                bg="red"
                style={{
                  border: "1px solid red",
                  marginLeft: isTab ? "0px" : "10px",
                  marginTop: isTab ? "15px" : "0px",
                }}
              >
                Clear
              </AuthButton>
            )}
          </div> */}
        </>
      )}
      <AccountSummaryWrapper>
        <table>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr style={{ fontWeight: "bold" }} key={index}>
                <td>
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div
                      style={{
                        height: "5px",
                        width: "5px",
                        padding: "5px",
                        borderRadius: "50%",
                        marginRight: "4px",
                        backgroundColor: colors.primary,
                      }}
                    ></div>
                    <span>{item.school}</span>
                  </div>
                </td>
                <td>{item.course}</td>
                <td>
                  {`${moment(item.startDate).format("YYYY")} - ${moment(
                    item.endData
                  ).format("YYYY")}`}
                </td>
                <td>
                  <button
                    style={{
                      borderWidth: "1px",
                      borderRadius: "5px",
                      borderColor: colors.primary,
                      color: "black",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      setObj(Object.assign({}, item));
                    }}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ textAlign: "center" }} colSpan={3}>
                No Educational Qualifications
              </td>
            </tr>
          )}
        </table>
      </AccountSummaryWrapper>
    </TabContentWrapper>
  );
};

Education.propTypes = {
  data: PropTypes.array,
  showForm: PropTypes.bool,
};

Education.defaultProps = {
  data: [],
  showForm: false,
};

export default Education;
